import { ALL_STORE } from "constants/DashboardContanst";
import { errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import DashboardService from "services/DashboardService";
import {
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  TENANT_CODE_HEADER,
} from "store/auth/login/actionTypes";
//Include Both Helper File with needed methods
import {
  getMonthlyData,
  getWeeklyData,
  getYearlyData,
} from "../../helpers/fakebackend_helper";
import {
  apiFail,
  apiSuccess,
  getChartsDataMessageStatusFail,
  getChartsDataMessageStatusSuccess,
  getListBUStoreHeaderFail,
  getListBUStoreHeaderSuccess,
  getListBUTenantHeaderFail,
  getListBUTenantHeaderSuccess,
  getListTenantHeaderFail,
  getListTenantHeaderSuccess,
  setBUStoreHeaderFail,
  setBUStoreHeaderSuccess,
} from "./actions";
// Crypto Redux States
import {
  GET_CHARTS_DATA,
  GET_CHARTS_DATA_MESSAGE_STATUS,
  GET_LIST_BU_STORE_HEADER,
  GET_LIST_BU_TENANT_HEADER,
  GET_LIST_TENANT_HEADER,
  SET_BU_STORE_HEADER,
  SET_BU_TENANT_HEADER,
  SET_TENANT_CODE_HEADER,
} from "./actionTypes";
function* fetchGetChartsDataMessageStatus({ tenantCode, year }) {
  try {
    const responseStatus = yield call(DashboardService.getChartPie, tenantCode);
    const responseSummary = yield call(
      DashboardService.getChartSummary,
      "total",
      tenantCode
    );
    const responseInvoice = yield call(
      DashboardService.getChartInvoice,
      "inyear",
      tenantCode
    );
    const chartsMLTDiep = {
      series: responseStatus.data,
      labels: responseStatus.data,
    };
    const chartMLTDiepInYear = responseSummary.data;
    const totalMessage = responseInvoice.data;
    yield put(
      getChartsDataMessageStatusSuccess(
        responseStatus,
        chartsMLTDiep,
        chartMLTDiepInYear,
        totalMessage
      )
    );
  } catch (error) {
    yield put(getChartsDataMessageStatusFail(errorMessage(error)));
  }
}
function* getChartsData({ payload: periodType }) {
  try {
    var response;
    if (periodType == "monthly") {
      response = yield call(getWeeklyData, periodType);
    }
    if (periodType == "yearly") {
      response = yield call(getYearlyData, periodType);
    }
    if (periodType == "weekly") {
      response = yield call(getMonthlyData, periodType);
    }

    yield put(apiSuccess(GET_CHARTS_DATA, response));
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, error));
  }
}

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData);
}

function* fetchSetTenantCodeHeader({ tenantCodeHeader }) {
  localStorage.setItem(TENANT_CODE_HEADER, tenantCodeHeader);
}

function* fetchSetBUTenantHeader({ buTenantHeader }) {
  localStorage.setItem(BU_TENANT_HEADER, buTenantHeader);
  //   localStorage.removeItem(BU_STORE_HEADER);
  //   try {
  //     // Call api
  //     const response = yield call(
  //       DashboardService.getListBUMethodSign,
  //       buTenantHeader,
  //       buTenantHeader
  //     );
  //     if (response && response.items) {
  //       yield put(setBUTenantHeaderSuccess(response.items));
  //     } else {
  //       yield put(setBUTenantHeaderFail("Lỗi"));
  //     }
  //   } catch (error) {
  //     yield put(setBUTenantHeaderFail(error));
  //   }
}

function* fetchGetListTenantHeader() {
  try {
    // Call api
    const response = yield call(DashboardService.getListTenantHeader);
    let listTenant = [];
    if (response && response.data) {
      listTenant = response.data.map(item => {
        return {
          label: item.tenantName,
          value: item.tenantCode,
        };
      });
    }
    yield put(getListTenantHeaderSuccess(listTenant));
  } catch (error) {
    yield put(getListTenantHeaderFail(error));
  }
}

function* fetchGetListBuTenantHeader() {
  try {
    // Call api
    const response = yield call(DashboardService.getListBUTenant);
    let listBU = [];
    if (response && response.items) {
      listBU = response.items.map(item => {
        return {
          ...item,
          itemBU: item,
          label: item.code + " - " + item.ten,
          value: item.id,
          code: item.code,
          is_release: item.is_release,
          parent_id: item.parent_id,
        };
      });
    }
    yield put(getListBUTenantHeaderSuccess(listBU));
  } catch (error) {
    yield put(getListBUTenantHeaderFail(error));
  }
}

function* fetchGetListBuStoreHeader({ parentId }) {
  try {
    // Call api
    const response = yield call(DashboardService.getListBUStore, parentId);
    let listBUStore = [];
    if (response && response.items) {
      listBUStore = response.items.map(item => {
        return {
          ...item,
          label: item.code + " - " + item.ten,
          value: item.code,
          hdbhang: item.hdbhang,
          hdbhdtqgia: item.hdbhdtqgia,
          hdbtscong: item.hdbtscong,
          hdgtgt: item.hdgtgt,
          hdkhac: item.hdkhac,
          invoice_type: item.invoice_type,
          is_release: item.is_release,
          parent_id: item.parent_id,
        };
      });
      if (listBUStore.length > 1) {
        listBUStore.unshift({
          label: "Tất cả",
          value: ALL_STORE,
        });
      }
    }
    // if(listBUStore.length===0){

    // }
    yield put(getListBUStoreHeaderSuccess(listBUStore));
  } catch (error) {
    yield put(getListBUStoreHeaderFail(error));
  }
}

function* fetchSetBUStoreHeader({ bUStoreHeader, shopCode }) {
  localStorage.setItem(BU_STORE_HEADER, shopCode);
  try {
    // Call api
    const response = yield call(
      DashboardService.getListBUMethodSign,
      bUStoreHeader,
      shopCode
    );
    // Call api
    const responseInfo = yield call(
      DashboardService.getListBUMethodSignInfo,
      shopCode
    );
    // Get info final level select store
    const { listBuStore, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    var value = null;
    let finalBuInfo = null;
    let finalBuReleaseInfo = null;
    if (listBuStore && listBuStore.length > 0) {
      value = listBuStore.find(item => item.value === shopCode);
      finalBuInfo = value;
    } else {
      value = listBuOfTenant.find(item => item.code === shopCode);
      finalBuInfo = value && value.itemBU;
    }
    //Nếu có sẽ lấy thông tin phát hành theo nó
    if (finalBuInfo.is_release) {
      finalBuReleaseInfo = finalBuInfo;
    } else {
      // Nếu có cha thì lấy theo cha, k có cha  thì lấy theo nó
      if (finalBuInfo.parent_id) {
        finalBuReleaseInfo = listBuOfTenant.find(
          item => item.id === finalBuInfo.parent_id
        );
      } else {
        finalBuReleaseInfo = finalBuInfo;
      }
    }
    // Nếu chọn tất cả đơn vị
    let finalListBuCode = [];
    if (shopCode === ALL_STORE) {
      const listAllStore = listBuStore
        .filter(item => item.value !== ALL_STORE)
        .map(item => item.code);
      finalListBuCode = listAllStore;
    } else {
      finalListBuCode = [shopCode];
    }
    if (response && response.items) {
      yield put(
        setBUStoreHeaderSuccess(
          response.items,
          responseInfo.items,
          shopCode,
          finalBuInfo,
          finalBuReleaseInfo,
          finalListBuCode
        )
      );
    } else {
      yield put(setBUStoreHeaderFail("Lỗi"));
    }
  } catch (error) {
    yield put(setBUStoreHeaderFail(error));
  }
}

function* dashboardSaga() {
  //   yield all([fork(watchGetChartsData)]);
  yield takeEvery(
    GET_CHARTS_DATA_MESSAGE_STATUS,
    fetchGetChartsDataMessageStatus
  );
  yield takeEvery(SET_TENANT_CODE_HEADER, fetchSetTenantCodeHeader);
  yield takeEvery(SET_BU_TENANT_HEADER, fetchSetBUTenantHeader);
  yield takeEvery(SET_BU_STORE_HEADER, fetchSetBUStoreHeader);

  yield takeEvery(GET_LIST_TENANT_HEADER, fetchGetListTenantHeader);
  yield takeEvery(GET_LIST_BU_TENANT_HEADER, fetchGetListBuTenantHeader);
  yield takeEvery(GET_LIST_BU_STORE_HEADER, fetchGetListBuStoreHeader);
}

export default dashboardSaga;
